import { createContext, useContext } from 'react';

import type { PlatformDragBoundaryRect } from './boundary';

export interface PlatformDragState {
    destinationIndex: number;
    draggableId: string;
    droppableId: string;
    sourceIndex: number;
}

export const PlatformDragStateContext = createContext<PlatformDragState | undefined>(undefined);

export const usePlatformDragState = (): PlatformDragState | undefined => useContext(PlatformDragStateContext);

export interface PlatformDragBoundaryContextValue {
    boundaryRect: PlatformDragBoundaryRect | null;
    registerDroppable: (droppableId: string, element: HTMLElement | null) => void;
}

export const PlatformDragBoundaryContext = createContext<PlatformDragBoundaryContextValue | undefined>(undefined);

export const usePlatformDragBoundary = (): PlatformDragBoundaryContextValue | undefined =>
    useContext(PlatformDragBoundaryContext);
